import { render, staticRenderFns } from "./Sandoz-Global.vue?vue&type=template&id=10c374e4&scoped=true"
import script from "./Sandoz-Global.vue?vue&type=script&lang=js"
export * from "./Sandoz-Global.vue?vue&type=script&lang=js"
import style0 from "./Sandoz-Global.vue?vue&type=style&index=0&id=10c374e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c374e4",
  null
  
)

export default component.exports